import http from './http';
import { Job, Transfer, Franchise, TransferRequest, RentalProperty, RentalRequest } from '@/types';

export interface SavedListing {
  id: string;
  userId: string;
  entityId: string;
  entityType: string;
  jobOffer?: Job;
  jobOfferRequest?: any;
  businessTransfer?: Transfer;
  businessTransferRequest?: TransferRequest;
  franchise?: Franchise;
  franchiseRequest?: any;
  rental?: RentalProperty;
  rentalRequest?: RentalRequest;
  createdAt: string;
}

export const savedListingApi = {
  getSavedListings: async (params?: { entityType?: string; page?: number; limit?: number; orderBy?: string; orderDirection?: string }): Promise<{ total: number; data: SavedListing[] }> => 
    http.get('/saved-listings', { params }).then((r) => {
      const mapItem = (item: any) => {
        if (item.entityData) {
          if (item.entityType === 'JobOffer') item.jobOffer = item.entityData;
          if (item.entityType === 'BusinessTransfer') item.businessTransfer = item.entityData;
          if (item.entityType === 'BusinessTransferRequest') item.businessTransferRequest = item.entityData;
          if (item.entityType === 'Franchise') item.franchise = item.entityData;
          if (item.entityType === 'Rental') item.rental = item.entityData;
          if (item.entityType === 'RentalRequest') item.rentalRequest = item.entityData;
        }
        return item as SavedListing;
      };

      if (r.data && typeof r.data.total === 'number' && Array.isArray(r.data.data)) {
        return { total: r.data.total, data: r.data.data.map(mapItem) };
      }
      if (r.data && Array.isArray(r.data)) {
        return { total: r.data.length, data: r.data.map(mapItem) };
      }
      if (r.data && Array.isArray(r.data.data)) {
        return { total: r.data.data.length, data: r.data.data.map(mapItem) };
      }
      return { total: 0, data: [] as SavedListing[] };
    }),

  saveListing: (entityId: string, entityType: string = 'JobOffer') => 
    http.post('/saved-listings', { entityId, entityType }).then((r) => r.data),

  unsaveListing: (entityId: string, entityType: string = 'JobOffer') => 
    http.delete('/saved-listings', { data: { entityId, entityType } }).then((r) => r.data),
};

